/**
 * Track events with Adalyser.
 *
 * @param event The event to track.
 */
export function adalyserTrack({ event }: { event: string }) {
  log('adalyserTrack', { event })

  window?.adalyserTracker?.('trackEvent', event)
}
